import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { serverRequest } from "../../util/server_request";
import { notifyUser } from "../../util/util";

export const contributionRatesKeys = {
  all: ["contribution-rates"],
  active: () => [...contributionRatesKeys.all, "active"],
};

export const useContributionRates = (options = {}) => {
  return useQuery({
    queryKey: contributionRatesKeys.active(),
    queryFn: async () => {
      const result = await serverRequest("GET", "profile/contribution-rates");
      return result?.data ?? result;
    },
    onError: (error) => notifyUser("error", error, "Error"),
    ...options,
  });
};

export const useUpsertContributionRates = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      return await serverRequest("POST", "profile/contribution-rates", payload);
    },
    onSuccess: (result) => {
      notifyUser("success", result?.data?.message || "Request successful", "Contribution Rates");
      queryClient.invalidateQueries({ queryKey: contributionRatesKeys.all });
    },
    onError: (error) => notifyUser("error", error, "Error"),
  });
};

